import { IndoorMapTest, PossiblePaths } from 'pages/custom/VipSenteret/IndoorMapTest';
import { CustomMapPage } from 'pages/custom/shared/CustomMapPage';
import { S_PageStyle } from 'pages/page/PageStyle';
import { useContext, useEffect, useState } from 'react';
import { CtxModal } from 'session/ctxModal';
import { CtxView } from 'session/ctxView';
import { Localization } from 'static/localization/localization';
import styled from 'styled-components/macro';
import { CompanyButtons } from 'pages/custom/shared/detail/CompanyButtons';

interface Props {
    className?: string;
}

export const VipSenteretPage = (props: Props): JSX.Element => {
    const ctxView = useContext(CtxView);
    const ctxModal = useContext(CtxModal);

    const [selected, setSelected] = useState<PossiblePaths | null>(null);

    useEffect(() => {
        const id = ctxModal.detailModal?.detail?.storyId;

        const run = async () => {
            if (id === '6f0621dc-05e7-42ce-b4e0-b0300c5677f9') {
                setSelected('proneo');
                return;
            }
            if (id === 'cef0050f-72d0-49ec-a52c-72ce599c19e4') {
                setSelected('sintef');
                return;
            }
            if (id === 'de2efedf-3451-4543-aa90-b50f78148d2c') {
                setSelected('norconsult');
                return;
            }
            if (id === 'faf8dacc-f9d5-4548-9572-e56c14cc99eb') {
                setSelected('toilet1');
                return;
            }
            setSelected(null);
        };
        run();
    }, [ctxModal.detailModal?.detail?.storyId]);

    return (
        <S_VIPSenteret className={props.className}>
            <CustomMapPage
                mapId={'a87f4404-146c-4eb4-b509-f2d12f634424'}
                header={{
                    logo: 'https://dvtqxks0zalev.cloudfront.net/9f26b7e8-05c6-4ae9-a4db-aa9f3dc4a331.png',
                    link: 'https://vipsenteret.no/',
                    linkText: Localization.WEBSITE
                }}
                controls={<CompanyButtons />}
                mapProps={{
                    light: {
                        anchor: 'viewport',
                        color: '#ccc',
                        intensity: 0.1
                    },
                    pitch: 20
                }}
                mapChildren={<IndoorMapTest mapRef={ctxView.mapRef} selectedPath={selected} />}
            />
        </S_VIPSenteret>
    );
};

const S_VIPSenteret = styled(S_PageStyle)`
    display: flex;
    flex-direction: column;
`;
